import { EquipmentTone } from "./EquipmentBox";

export const CLIP_EMPTY_THRESHOLD = 0;
export const CLIP_LOW_THRESHOLD = 3;

export const estopTone = (
	value: number | null | undefined,
	polarity: "lowTriggered" | "highTriggered" = "lowTriggered",
): EquipmentTone => {
	if (value === null || value === undefined) return "unknown";
	const triggered = polarity === "lowTriggered" ? value === 0 : value !== 0;
	return triggered ? "alert" : "ok";
};

export const robotTone = (
	cycling: number | null | undefined,
	alarm: number | null | undefined,
): EquipmentTone => {
	if (alarm === 1) return "alert";
	if (cycling === null || cycling === undefined) return "unknown";
	return cycling === 1 ? "ok" : "info";
};

export const hydTempTone = (
	hiAlarm: number | null | undefined,
	loAlarm: number | null | undefined,
): EquipmentTone => {
	if (hiAlarm === 1) return "alert";
	if (loAlarm === 1) return "warn";
	if (hiAlarm === null || hiAlarm === undefined) return "unknown";
	return "ok";
};

export const clipLowTone = (
	count: number | null | undefined,
): EquipmentTone => {
	if (count === null || count === undefined) return "unknown";
	if (count <= CLIP_EMPTY_THRESHOLD) return "alert";
	if (count < CLIP_LOW_THRESHOLD) return "warn";
	return "ok";
};

export const driveEnabledTone = (
	value: number | null | undefined,
): EquipmentTone => {
	if (value === null || value === undefined) return "unknown";
	return value ? "ok" : "disabled";
};

export const autoCleanTone = (
	value: number | null | undefined,
): EquipmentTone => {
	if (value === 1) return "cleaning";
	return "unknown";
};
